import React from 'react'
import OpeningPage from '../components/OpeningPage'

const GetStart = () => {
  return (
    <>
       <div>
          <OpeningPage/>
       </div>
    </>
  )
}

export default GetStart
